import React, { useState } from 'react'
import DropdownContainer from '../../../DropdownContainer/DropdownContainer'
import { MagicOutlineIcon } from '../../../../images/common'
import './AskVisoModels.scss'

const AskVisoModels = ({ color, setModelType, modelType, contextType, modelList }) => {
  const [showModels, setShowModels] = useState(false)
  
  const removeFast = () => {
    if(contextType === 'dashboardBuilding') {
      return modelList.filter(option => option.label !== 'Fast')
    }
    return modelList
  }

  return (
    <div className='ask-viso-models'>
      <button
        onClick={() => setShowModels(!showModels)}
        className='ask-viso-models__dropdown'
      >
        <MagicOutlineIcon />
        {modelType.label}
      </button>
      {showModels &&
        <DropdownContainer
          actions={removeFast()}
          showDropdown={showModels}
          setShowDropdown={setShowModels}
          position='left'
          listClick={setModelType}
          dropUp
          color={color}
          hasBadges
          disabled={modelType}
        />
      }
    </div>
  )
}

export default AskVisoModels